module.exports = __webpack_public_path__ + "img/qrcode2.fa7ea6ab.png";